<template>

<div v-if="visible" class="fade-in-only grey--text" style="width:100%;padding:20px;" >
    <v-icon style="font-size:250px;color:#ccc;">chat_bubble_outline</v-icon>
    <div style="font-size:20px;color:#aaa;padding-left:18px;margin-top:-10px" >
        <slot>{{message}}</slot>
    </div>   
</div>

</template>

<script>

export default {
    data() {
        return {
            visible: false,
        }
    },
    
    props: {
        delay: {
            type: Number,
            default:4000,
        },
        message: {
            type: String,
            default: 'No Records'
        },
        icon: String,  //not yet used
    },

    components: {
        
    },

    computed: {
       
    },

    methods: {

    },

    mounted() {
        setTimeout( () => {
            this.visible = true
        }, this.delay)
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// NoRecordsPlaceholder.vue?499c41e8